//creatives.js
export const ADD_CREATIVE = "ADD_CREATIVE";
export const ADD_CREATIVES = "ADD_CREATIVES";
export const ADD_DCM_CREATIVES = "ADD_DCM_CREATIVES";
export const ADD_DIMENSIONS = "ADD_DIMENSIONS";
export const REMOVE_CREATIVE = "REMOVE_CREATIVE";
export const EDIT_CREATIVE = "EDIT_CREATIVE";
export const SELECT_CREATIVE = "SELECT_CREATIVE";
export const DESELECT_CREATIVE = "DESELECT_CREATIVE";
export const CLEAR_SELECTED_CREATIVES = "CLEAR_SELECTED_CREATIVES";
export const SET_WEIGHT_DISTRIBUTION = "SET_WEIGHT_DISTRIBUTION";
export const SET_ROTATION_TYPE = "SET_ROTATION_TYPE";
export const SET_ASSIGNED_PLACEMENTS = "SET_ASSIGNED_PLACEMENTS";
export const REORDER_CREATIVES = "REORDER_CREATIVES";
export const SET_START_DATE = "SET_START_DATE";
export const SET_END_DATE = "SET_END_DATE";
export const SET_HARD_CUTOFF = "SET_HARD_CUTOFF";
export const SET_CREATIVE_API_ERROR = "SET_CREATIVE_API_ERROR";
export const ADD_BACKUP = "ADD_BACKUP";
export const RESET_CREATIVE_STATE = "RESET_CREATIVE_STATE";
export const SET_DYNAMIC_TARGETING_KEYS = "SET_DYNAMIC_TARGETING_KEYS";

export const WEIGHT_OPTIONS = {
  EVEN: "EVEN",
  CUSTOM: "CUSTOM"
};

export const ROTATION_TYPES = {
  CLICK_THROUGH_RATE: "CLICK_THROUGH_RATE",
  WEIGHTED: "WEIGHTED",
  SEQUENTIAL: "SEQUENTIAL"
};

//global.js
export const START_LOAD = "START_LOAD";
export const STOP_LOAD = "STOP_LOAD";
export const SET_AUTH_ERROR = "SET_AUTH_ERROR";
export const CLEAR_AUTH_ERROR = "CLEAR_AUTH_ERROR";
export const UPDATE_SMART_LOADER = "UPDATE_SMART_LOADER";

//navigation.js
export const SET_ACTIVE_ROUTE = "SET_ACTIVE_ROUTE";

export const ROUTES = {
  NAMING_GENERATOR: "NAMING_GENERATOR",
  CREATIVE_TRAFFICKER: "CREATIVE_TRAFFICKER",
  PLACEMENT_LIST: "PLACEMENT_LIST",
  CHANGE_LOG: "CHANGE_LOG"
};
